<template>
    <Card :header="$t('currentListOfOffers')">
        <OfferListDataTable
            :header="$t('displayedOnYourWebsite')"
            :items="fetchDataIn"
        />
        <OfferListDataTable
            :header="$t('notDisplayedOnYourWebsite')"
            :items="fetchDataNotIn"
        />
    </Card>
</template>



<script>
    import OfferListDataTable from './OfferListDataTable.vue';

    export default {
        name: 'OfferList',
        components: {
            OfferListDataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.$req('producerProduct/offers'),
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            data() {
                return this.request.getData() || [];
            },
        },
        methods: {
            fetchDataIn() {
                return this.request.get({ urlParams: { id: this.item.id }, requestParams: { pluginOffers: 'in' } }).then(data => data?.items || []);
            },
            fetchDataNotIn() {
                return this.request.get({ urlParams: { id: this.item.id }, requestParams: { pluginOffers: 'notIn' } }).then(data => data?.items || []);
            },
        },
    };
</script>
